import React from "react";
import AuthService from "../services/auth.service";
import DashboardService from "../services/dashboard.service";
import Account from "../components/Account";

const AccountPage: React.FC = () => {
    

    return (
       <Account/>
    );
}

export default AccountPage; 
